import React, { Fragment } from 'react';
import { TableCell } from '../TableCell';
import { ContentParagraph, ContentParagraphModifier } from '../../../../_lib/components/ContentParagraph';
import ContentNote from '../../../../_lib/components/ContentNote/ContentNote';
import { Icons } from '../../../atoms/SVG';
import { ExtendedInfoSVG } from '../../../../_lib/components/ExtendedInfo';
import { TooltipPlacement } from '../../../atoms/Tooltip';
import { useSonTranslation } from '../../../../translation/useSonTranslation';

type TableCellRole = {
  label: string;
  url?: string;
  roles: { name: string; note?: string; automaticallyAssigned?: boolean }[];
  cellProperties?: TableCell;
};
export function TableCellRole({ label, cellProperties, roles }: TableCellRole) {
  const { t } = useSonTranslation('MemberRow');

  return (
    <TableCell {...cellProperties} dataHead={label}>
      {roles.map(role => (
        <Fragment key={role.name}>
          <ContentParagraph modifier={ContentParagraphModifier.FLEX}>
            {role.name}
            {role.automaticallyAssigned && (
              <ExtendedInfoSVG
                helpText={t('roles.automaticallyAssigned')}
                tooltipPlacement={TooltipPlacement.TOP}
                svgSpriteID={Icons.AUTOMATIC}
              />
            )}
          </ContentParagraph>
          {role.note && <ContentNote modifier="margin-bottom" key={role.note} type="note" note={role.note} />}
        </Fragment>
      ))}
    </TableCell>
  );
}
